import classNames from 'classnames/bind';
import React from 'react';
import { RiEyeLine, RiEyeOffLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';

import styles from './Item.module.scss';

import actions from '@/actions';
import { useFCTelemetryHandler } from '@/hooks/mavlinkTelemetryHandlers';

const cx = classNames.bind(styles);

const Item = ({ robot }) => {
  const dispatch = useDispatch();

  useFCTelemetryHandler(robot, [33]);

  const toggleShow = () => {
    dispatch(actions.robots.toggleShow(robot.id));
  };

  return (
    <div className={cx('container')}>
      <div className={cx('color')} style={robot.isActive ? { backgroundColor: robot.color } : null} />
      <div className={cx(['name', { active: robot.isActive }])}>{robot.name}</div>
      {robot.isActive && (
        <div className={cx('button')} onClick={toggleShow}>
          {robot.isShow && <RiEyeLine size={14} color="white" />}
          {!robot.isShow && <RiEyeOffLine size={14} color="white" />}
        </div>
      )}
    </div>
  );
};

export default Item;
